/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {OverviewAdSale, OverviewPeriodRange} from '../../../../util/interfaces';

import {getOverviewAdRevenue} from '../../../../util/requestSender';

import {useOverviewSection} from '../useOverviewSection';

import AdRevenue from './adRevenue';

interface Props {
    accountIds: Array<string>;
    period: OverviewPeriodRange;
}

export default function AdRevenueController({accountIds, period}: Props) {
    const section = useOverviewSection<OverviewAdSale>({request: getOverviewAdRevenue, accountIds, period});

    return <AdRevenue {...section} />;
}
